import { render, staticRenderFns } from "./DuelsGameWinner.vue?vue&type=template&id=46278915&scoped=true"
import script from "./DuelsGameWinner.vue?vue&type=script&lang=js"
export * from "./DuelsGameWinner.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameWinner.vue?vue&type=style&index=0&id=46278915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46278915",
  null
  
)

export default component.exports